import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import theme from '@hellodarwin/core/lib/theme';
import Empty from 'antd/lib/empty';
import { useGinSteps } from '../../../../gin-steps-provider';
import { useParsedGinRichText } from './use-parsed-gin-rich-text';
import { GinStepRichTextContentContainer, GinStepRichTextContentContent, } from './styles';
const GinStepRichTextContent = ({ itemId, richTextContent, }) => {
    const { t } = useTranslations();
    const processedContent = useParsedGinRichText({
        richText: richTextContent,
        itemId,
    });
    const { viewMode } = useGinSteps();
    const isAdminView = viewMode === 'admin_fr' || viewMode === 'admin_en';
    return (_jsx(GinStepRichTextContentContainer, { children: processedContent ? (_jsx(GinStepRichTextContentContent, { children: processedContent })) : isAdminView ? (_jsx(Empty, { description: _jsx(Typography, { elementTheme: "subtitle2", color: theme.colors.grey_2, children: t('gin_steps|no_content') }) })) : (_jsx(_Fragment, {})) }));
};
export default GinStepRichTextContent;
